import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36abfbca")

_pushScopeId("data-v-36abfbca")
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "field has-addons" }
const _hoisted_4 = { class: "control is-expanded has-icons-left" }
const _hoisted_5 = { class: "icon is-small is-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "control" }, [
  /*#__PURE__*/_createVNode("input", {
    class: "button is-primary",
    type: "submit",
    value: "Find"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("form", {
    onSubmit: [
      _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
    ]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            type: "text",
            pattern: _ctx.pattern,
            title: _ctx.title,
            class: "input",
            placeholder: _ctx.label,
            "aria-label": _ctx.label,
            "aria-describedby": _ctx.label,
            onOninvalid: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setTitle && _ctx.setTitle(...args))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value = $event)),
            required: ""
          }, null, 40, ["pattern", "title", "placeholder", "aria-label", "aria-describedby"]), [
            [_vModelText, _ctx.value]
          ]),
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: "search" })
          ])
        ]),
        _hoisted_6
      ])
    ])
  ], 32))
})